
const path = require('path');

const config = new Map();

try {
  // eslint-disable-next-line global-require
  const gitInfo = require('../src/gitInfo.json');
  config.set('gitBranch', gitInfo.gitBranch);
  config.set('gitHash', gitInfo.gitCommitHash);
} catch (error) {
  config.set('gitBranch', '');
  config.set('gitHash', '');
}

let server = process.env.SERVER;
if (!server) {
  server = 'development';
}
let env = process.env.NODE_ENV;
if (!env) {
  env = 'development';
}

config.set('server', server);
// Known OP UAT destination; production needs its own confirmed UI URL.
config.set('outperformURL', server === 'uat' ? 'https://app-r1.outperformhq.io/cloud-uat/' : '');
config.set('env', env);
config.set('dirSrc', path.resolve(__dirname, '../src'));
config.set('dirBuild', path.resolve(__dirname, '../build'));
config.set('gaID', process.env.GA_ID || 'G-TKZYFP747F');

config.set('startURL', 'https://secure.mhub.my');
config.set('apiURL', 'https://api.mhub.my');
config.set('bookApiURL', '');
config.set('loanTrackerURL', 'http://loantracker.mhub.my');
config.set('salesChartURL', 'http://siteplan.mhub.my');
config.set('mpBucket', 'mhub-box-assets-prod');
config.set('mpURL', 'https://marketplace.mhub.my');
config.set('remarksURL', 'https://remarks.mhub.my');
config.set('versionCheck', true);
config.set('clooneURL', 'https://lawyer-api.mhub.my');
config.set('subscriptionApiEndpoint', 'https://fohmcmwftfeg7acwtqd7m72mwu.appsync-api.ap-southeast-1.amazonaws.com/graphql');
config.set('developerURL', 'https://developer.mhub.my');
config.set('analyticsURL', 'https://developer.mhub.my/analytics/sales/overview');
config.set('buyerURL', 'https://buyer.mhub.my');
config.set('logApiURL', 'https://log.mhub.my');
config.set('tzName', process.env.TZ_NAME || 'Asia/Kuala_Lumpur');

// Q Help, the in-app support widget (src/utils/qHelpWidget.js): one prebuilt script per environment,
// built in mhub-web-turborepo apps/mhub-q-help-widget. Each build reads one Cognito pool's cookies
// and talks to one Q, so an environment only points at the build for its own pool. Empty = no tag
// (and no help launcher at all). Q_HELP_WIDGET_URL, below, overrides it.
config.set('qHelpWidgetURL', 'https://help-widget.mhub.my/v1/widget.js');

if (config.get('server') === 'staging') {
  config.set('apiURL', 'https://api-dev.mhub.my');
  config.set('startURL', 'https://stage.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker-dev.mhub.my');
  config.set('salesChartURL', 'http://siteplan-staging.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-stage');
  config.set('mpURL', 'https://marketplace.stage.mhub.my');
  config.set('remarksURL', 'https://remarks.stage.mhub.my');
  config.set('clooneURL', 'https://lawyer-stage-api.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://25zoqekpmjeonp7aqfkvhd4fu4.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('developerURL', 'https://developer.stage.mhub.my');
  config.set('analyticsURL', 'https://developer.stage.mhub.my/analytics/sales/overview');
  config.set('logApiURL', 'https://log.stage.mhub.my');
  config.set('buyerURL', 'https://enterprise-buyer.mhub.ninja');
  config.set('qHelpWidgetURL', 'https://help-widget-staging.mhub.my/v1/widget.js');
}

if (config.get('server') === 'demo') {
  config.set('apiURL', 'https://api-demo.mhub.my');
  config.set('startURL', 'https://demo.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker-demo.mhub.my');
  config.set('salesChartURL', 'https://siteplan-demo.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-demo');
  config.set('mpURL', 'https://marketplace.demo.mhub.my');
  config.set('remarksURL', 'https://remarks.demo.mhub.my');
  config.set('clooneURL', 'https://lawyer-demo-api.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://bld5c3zytba7jc4ncumkibyjaq.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('developerURL', 'https://developer.demo.mhub.my');
  config.set('analyticsURL', 'https://developer.demo.mhub.my/analytics/sales/overview');
  config.set('logApiURL', 'https://log.demo.mhub.my');
  config.set('buyerURL', 'https://buyer-demo.mhub.my');
  config.set('qHelpWidgetURL', '');
}

if (config.get('server') === 'development') {
  // Defaults preserve the EXISTING local-dev setup (mhub.local domains) — unchanged when no env is
  // set. mhub-devstack overrides them via env (MHUB_API_URL / BOOK_API_URL / MHUB_START_URL) to point
  // at local backends behind Caddy. bookApiURL is only set when provided, so non-devstack behaviour
  // is byte-identical to before.
  config.set('apiURL', process.env.MHUB_API_URL || 'http://api.mhub.local:8010');
  config.set('startURL', process.env.MHUB_START_URL || 'http://web.mhub.local:3009');
  if (process.env.BOOK_API_URL) {
    config.set('bookApiURL', process.env.BOOK_API_URL);
  }
  config.set('loanTrackerURL', 'http://web.mhub.local:3012');
  config.set('salesChartURL', 'http://dev.mhub.local:3001');
  config.set('mpBucket', 'mhub-box-assets-dev');
  config.set('mpURL', 'http://dev.mhub.local:3000');
  config.set('remarksURL', 'http://dev.mhub.my:3000');
  config.set('clooneURL', 'https://lawyer-dev-api.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://idneybrr3zfxnipzv2toptjjx4.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('subsAuth', '');
  config.set('developerURL', 'http://dev.mhub.local:3000');
  config.set('logApiURL', 'https://log.uat.mhub.my');
  config.set('buyerURL', 'http://localhost:5173');
  // Off unless Q_HELP_WIDGET_URL is set (mhub-devstack sets it to its local widget).
  config.set('qHelpWidgetURL', '');
}

if (config.get('server') === 'development-remote') {
  config.set('apiURL', 'https://api-dev.mhub.my');
  config.set('startURL', 'https://stage.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker-dev.mhub.my');
  config.set('salesChartURL', 'http://siteplan-staging.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-stage');
  config.set('mpURL', 'https://marketplace.stage.mhub.my');
  config.set('remarksURL', 'https://remarks.stage.mhub.my');
  config.set('clooneURL', 'https://lawyer-stage-api.mhub.my');
  config.set('logApiURL', 'https://log.stage.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://25zoqekpmjeonp7aqfkvhd4fu4.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('qHelpWidgetURL', 'https://help-widget-staging.mhub.my/v1/widget.js');
}

if (config.get('server') === 'uat') {
  config.set('apiURL', 'https://api.uat.mhub.my');
  config.set('startURL', 'https://secure.uat.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker.uat.mhub.my');
  config.set('salesChartURL', 'https://siteplan.uat.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-uat');
  config.set('mpURL', 'https://marketplace.uat.mhub.my');
  config.set('remarksURL', 'https://remarks.uat.mhub.my');
  config.set('clooneURL', 'https://lawyer-api.uat.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://b73loqbjdfhj7bu4r32fn6f7te.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('developerURL', 'https://developer.uat.mhub.my');
  config.set('logApiURL', 'https://log.uat.mhub.my');
  config.set('analyticsURL', 'https://developer.uat.mhub.my/analytics/sales/overview');
  config.set('buyerURL', 'https://buyer.uat.mhub.my');
  // UAT's own Cognito pool has its own widget build, talking to Q UAT.
  config.set('qHelpWidgetURL', 'https://help-widget-uat.mhub.my/v1/widget.js');
}

config.set('s3Region', 'ap-southeast-1');
config.set('s3SiteplanRegion', 'ap-southeast-1');

let faviconPath = process.env.FAVICON_PATH;
if (!faviconPath || faviconPath === '') {
  faviconPath = '/assets/images';
}
config.set('faviconPath', faviconPath);

let mhubLoader = process.env.MHUB_LOADER;
if (!mhubLoader || mhubLoader === '1') {
  mhubLoader = true;
} else {
  mhubLoader = false;
}
config.set('mhubLoader', mhubLoader);

let prs = process.env.IS_PRS;
if (prs === 'true') {
  prs = true;
} else {
  prs = false;
}
config.set('prs', prs);

let isPackagePricingRequired = process.env.REQUIRED_BOOKING_PRICING_PACKAGE;
if (isPackagePricingRequired === 'true') {
  isPackagePricingRequired = true;
} else {
  isPackagePricingRequired = false;
}
config.set('isPackagePricingRequired', isPackagePricingRequired);

let versionCheck = process.env.VERSION_CHECK;
if (versionCheck === 'false') {
  versionCheck = false;
} else {
  versionCheck = true;
}
config.set('versionCheck', versionCheck);

let appTitle = process.env.APP_TITLE;
if (!appTitle || appTitle === '') {
  appTitle = 'MHub';
}
config.set('appTitle', appTitle);

// Bugsnag's release stage. The vendored notifier defaults this to "production" whenever the
// script tag omits data-releasestage (`x("releaseStage", "production")` in snagerror.js), so
// until this was wired EVERY build — uat, staging, demo and a developer's local devstack —
// reported its errors as production: billed to the production 5k/day quota and mixed into
// production error analysis (MS-6583).
//
// RELEASE_STAGE is the right source and already exists: a per-environment CI variable
// (prod/fab/ijm/pr1ma/spsetia => production, uat => uat, staging => staging, demo => demo)
// that build-deploy.yml exports before `make build`. NOT config.get('env') — that is NODE_ENV,
// which is "production" for every deployed build, uat included. `server` is the local
// fallback ('development' when nothing sets it) so a devstack build stops claiming to be
// production. Sanitised: the value is interpolated into an HTML attribute in book.html.
const releaseStage = String(process.env.RELEASE_STAGE || config.get('server') || 'development')
  .toLowerCase()
  .replace(/[^a-z0-9._-]/g, '')
  .slice(0, 32) || 'development';
config.set('releaseStage', releaseStage);

config.set('appName', `mhub-book-web-${config.get('env')}`);

config.set('secureDocumentsSharingWidgetURL', process.env.MHUB_SECUREDOCUMENTSSHARING_WIDGET_URL);
config.set('secureDocumentsApiURL', process.env.MHUB_SECUREDOCUMENTS_API_URL);
config.set('secureDocumentsBoxURL', process.env.MHUB_SECUREDOCUMENTS_BOX_URL);

// overwite environment configs
if (process.env.MHUB_API_URL) {
  config.set('apiURL', process.env.MHUB_API_URL);
}
if (process.env.MHUB_LOG_API_URL) {
  config.set('logApiURL', process.env.MHUB_LOG_API_URL);
}
if (process.env.MHUB_START_URL) {
  config.set('startURL', process.env.MHUB_START_URL);
}
if (process.env.Q_HELP_WIDGET_URL) {
  config.set('qHelpWidgetURL', process.env.Q_HELP_WIDGET_URL);
}
config.set('version', process.env.VERSION);

config.set('crmKey', process.env.CRM_KEY);

// OpenTelemetry (OTEL-6). Injected at build time by config/webpack/*.js DefinePlugin, the same
// way every other value above arrives — there is no runtime env in a browser bundle.
//
// Tracing FAILS OPEN: with otelEndpoint empty the app runs exactly as before and src/lib/telemetry.js
// returns before touching the SDK. Endpoint and headers travel together on purpose — SigNoz's OTLP
// receivers are bearer-gated, so an endpoint configured without its token is answered 401.
config.set('otelEndpoint', process.env.OTEL_EXPORTER_OTLP_ENDPOINT || '');
config.set('otelHeaders', process.env.OTEL_EXPORTER_OTLP_HEADERS || '');
// The account-scoped AWS `environment` tag value (e.g. "staging2") => deployment.environment, so
// browser spans land in the same environment bucket as the Go services. NOT releaseStage: that is
// the application environment and names resources. telemetrySdk.js falls back to releaseStage only
// while RESOURCE_ENVIRONMENT is not yet set in CI.
config.set('otelResourceEnvironment', process.env.RESOURCE_ENVIRONMENT || '');
// Head-sampling ratio, 0 to 1, for the traces this browser starts (parentbased_traceidratio).
// Empty means 1 — every trace. src/lib/telemetry.js parseSamplerRatio() validates it.
config.set('otelSamplerRatio', process.env.OTEL_TRACES_SAMPLER_ARG || '');

module.exports = config;



// WEBPACK FOOTER //
// ./config/index.js